export const ALERT_ACTION_TYPES = {
	ALERT_OPEN_ALERT: 'ALERT_OPEN_ALERT',
	ALERT_CLOSE_ALERT: 'ALERT_CLOSE_ALERT',
	ALERT_OPEN_PROMPT: 'ALERT_OPEN_PROMPT',
	ALERT_CLOSE_PROMPT: 'ALERT_CLOSE_PROMPT'
};

const DEFAULT_ALERT_CHOICES = [{text: 'OK', action: () => true}];

export const openAlert = (title, message, choices = DEFAULT_ALERT_CHOICES) => {
	return {
		type: ALERT_ACTION_TYPES.ALERT_OPEN_ALERT,
		payload: { title, message, choices }
	};
};

export const closeAlert = () => {
	return {
		type: ALERT_ACTION_TYPES.ALERT_CLOSE_ALERT,
		payload: {}
	};
};

export const openPrompt = (promptText, action, initialValue, placeholder) => {
	return {
		type: ALERT_ACTION_TYPES.ALERT_OPEN_PROMPT,
		payload: { promptText, action, initialValue, placeholder }
	};
};

export const closePrompt = () => {
	return {
		type: ALERT_ACTION_TYPES.ALERT_CLOSE_PROMPT,
		payload: {}
	};
};

export default (state, action) => {
	const { type, payload } = action;
	switch (type) {
		case ALERT_ACTION_TYPES.ALERT_OPEN_ALERT: {
			const { title, message, choices } = payload;

			return {
				...state,
				alert: {
					title,
					message,
					choices
				}
			};
		}
		case ALERT_ACTION_TYPES.ALERT_CLOSE_ALERT: {
			return {
				...state,
				alert: null
			};
		}
		case ALERT_ACTION_TYPES.ALERT_OPEN_PROMPT: {
			const { promptText, action, initialValue, placeholder } = payload;

			return {
				...state,
				prompt: {
					promptText,
					action,
					initialValue,
					placeholder
				}
			};
		}
		case ALERT_ACTION_TYPES.ALERT_CLOSE_PROMPT: {
			return {
				...state,
				prompt: null
			};
		}
		default:
			console.log('action type not found: ', type);
			return state;
	}
};
